import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs';
import { Event } from '../class/event/event';
import { Patient } from '../class/patient/patient';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {


  constructor(private _ref: ChangeDetectorRef) { }


  transform(patients: Patient[], field: string, events: Event[],) {

    if (!events || !patients) return patients;

    patients.map(function (patient) {
      const event = events.find((event) => {
        return event["patient_id"] == patient.patient_id;
      });
      patient.latestDate = event ? event.date : 999999999999999999;
      return patient;
    });



    if ("events" !== field) {
      patients.sort((a: any, b: any) => {
        if (a[field] < b[field]) {
          return -1;
        } else if (a[field] > b[field]) {
          return 1;
        } else {
          return 0;
        }
      });
      return patients;
    } else {
      patients.sort((a: any, b: any) => {
        if (a.latestDate < b.latestDate) {
          return -1;
        } else if (a.latestDate > b.latestDate) {
          return 1;
        } else {
          return 0;
        }
      });
      return patients;

    }

  }

}
